import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { createAdminUnit } from '../../../services/adminUnits';
import { getOrganizations } from '../../../services/organizations';
import { useAuth } from '../../../hooks/useAuth';
import Input from '../../../components/Forms/Input';
import Select from '../../../components/Forms/Select';

const AdminUnitForm = ({ parentId, onSuccess }) => {
  const { user } = useAuth();
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      name: '',
      code: '',
      level: 1,
      organization_id: '',
    },
  });

  useEffect(() => {
    if (user?.role === 'super_admin') {
      loadOrganizations();
    }
  }, [user]);

  const loadOrganizations = async () => {
    try {
      const data = await getOrganizations();
      setOrganizations(Array.isArray(data) ? data : data?.data || []);
    } catch (err) {
      console.error('Failed to load organizations', err);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = { ...data, parent_id: parentId };
      if (user?.role === 'super_admin' && !payload.organization_id) {
        alert('Please select an organization');
        setLoading(false);
        return;
      }
      await createAdminUnit(payload);
      reset(); // clear form
      onSuccess();
    } catch (err) {
      alert(err.response?.data?.error || 'Creation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {user?.role === 'super_admin' && (
        <Select
          name="organization_id"
          control={control}
          label="Organization"
          options={organizations.map((org) => ({
            value: org.id,
            label: org.name,
          }))}
          rules={{ required: 'Organization is required' }}
        />
      )}
      <Input name="name" control={control} label="Unit Name" rules={{ required: true }} />
      <Input name="code" control={control} label="Unit Code" rules={{ required: true }} />
      <Input
        name="level"
        control={control}
        label="Level Number"
        type="number"
        rules={{ required: true, min: 1 }}
      />
      <button type="submit" disabled={loading}>
        {loading ? 'Creating...' : 'Create'}
      </button>
    </form>
  );
};

export default AdminUnitForm;